
export const styleBoxCalendar={
    ml:"15px",
    position:"absolute",
    height:"150px",
    width:"100%",
    border:"0,5px solid",
    display:"flex",
    backgroundColor:"white"
}
export const styleGridCalendar={
    pl:"70px"
}